import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Text,
} from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { signIn, useGetPathAfterLogin } from "features/auth/AuthUtils";
import { useTokenCreate } from "gen/endpoints/token/token";
import { ClientsTokenObtainPairRequest } from "gen/model/clientsTokenObtainPairRequest";
import { tokenCreateBody } from "gen/schemas/token/token";
import React, { useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Form from "shared/components/form/Form";
import { FormTextInput } from "shared/components/input/text/TextInput";

// NOTE: This component is used only for login in a development environment.
export const LoginSimplePage: React.FC = () => {
  const navigate = useNavigate();
  const getPathAfterLogin = useGetPathAfterLogin();

  const { t } = useTranslation(["auth"]);

  const form = useForm({
    resolver: zodResolver(tokenCreateBody),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const { mutateAsync: signInSimple, isPending: isLoadingSignIn } =
    useTokenCreate();

  const onSubmit = useCallback(
    async (data: ClientsTokenObtainPairRequest) => {
      const response = await signInSimple({ data });
      await signIn(response);
    },
    [signInSimple],
  );

  return (
    <Form
      form={form}
      disableNavBlocker={true}
      onSubmit={onSubmit}
      onSuccess={() => {
        navigate(getPathAfterLogin(), { replace: true });
      }}
    >
      <Card width="md">
        <CardHeader>
          <Text textStyle="h4">{t("auth:login")}</Text>
        </CardHeader>
        <CardBody>
          <FormTextInput
            name="email"
            title={t("auth:emailAddress")}
            autoFocus={true}
          />
          <FormTextInput
            name="password"
            title={t("auth:password")}
            type="password"
          />
        </CardBody>
        <CardFooter mt="-16px" justifyContent="flex-end">
          <Button type="submit" isLoading={isLoadingSignIn}>
            {t("auth:signIn")}
          </Button>
        </CardFooter>
      </Card>
    </Form>
  );
};
